module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Group_16"],"path":[{"$":{"d":"M16,11.18V15H6V11.18C6,9.46,8.23,8,11,8S16,9.46,16,11.18ZM11,1a3,3,0,1,0,3,3A3,3,0,0,0,11,1ZM7.24,8.36A7.13,7.13,0,0,0,5,8C2.23,8,0,9.46,0,11.18V15H4.5V11.18C4.5,10,5.62,8.9,7.24,8.36ZM6.5,4a3,3,0,0,1,.74-2A3,3,0,0,0,5,1,3,3,0,0,0,5,7,3,3,0,0,0,7.24,6,3,3,0,0,1,6.5,4Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Group_16.svg
// module id = Qto8
// module chunks = 1